import React, { FC, ReactElement } from 'react';
import { SquareMultiplierEnum } from '../game/Enums';
import SquareContents from '../game/SquareContents';

interface SquareProps {
    contents: SquareContents;
    x: number;
    y: number;
    omd: Function;
    omu: Function;
    omo: Function;
    ote: Function;
}

const Square: FC<SquareProps> = ({ contents, x, y, omd, omu, omo, ote, children }) => {

    return (
        <div
            className={'Square ' + contents.classes}
            data-multiplier={contents.multiplier}
            onMouseDown={() => omd(x, y)}
            onMouseUp={() => omu(x, y)}
            onMouseOver={() => omo(x, y)}
            onTouchStart={() => omd(x, y)}
            onTouchEnd={() => ote()}
        >

            <div className={'SquareContents '}
                data-x={x}
                data-y={y}>
                {contents.char}
                {contents.pointValue > 0 ? <sub>{contents.pointValue}</sub> : ''}
            </div>

        </div>
    );
};

export default Square;